import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { PreviewDataType } from '../../enums/preview-data-type.enum';
import { TagSeverity } from '../../enums/tag-severity.enum';
import { CurrencyPipe, DatePipe, JsonPipe, PercentPipe } from '@angular/common';
import { Checkbox } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { Tag } from 'primeng/tag';
import { Tooltip } from 'primeng/tooltip';

@Component({
  standalone: true,
  selector: 'app-preview-data-wrapper',
  imports: [
    DatePipe,
    JsonPipe,
    PercentPipe,
    CurrencyPipe,
    Checkbox,
    FormsModule,
    Tag,
    Tooltip,
  ],
  templateUrl: './preview-data-wrapper.component.html',
  styleUrl: './preview-data-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewDataWrapperComponent {
  public label = input<string | null>();
  public labelTooltip = input<string | undefined>();
  public data = input<any>();
  public dataType = input<PreviewDataType>(PreviewDataType.TEXT);
  public statusSeverity = input<TagSeverity | null>(null);
  public additionalCssClasses = input<string | null>();
  public additionalCssClassesForTextData = input<string | null>();
  public additionalCssForDlElement = input<string | null>();
  public emptyValue = input<string>('-');

  protected readonly textValue = computed(() =>
    this.#normalizeTextValue(this.data()),
  );

  #normalizeTextValue(value: unknown): string {
    if (value == null) {
      return this.emptyValue();
    }

    if (typeof value !== 'string') {
      return String(value);
    }

    const normalized = value.trim();

    return normalized ? normalized : this.emptyValue();
  }

  protected readonly PreviewDataType = PreviewDataType;
}
